export default __webpack_public_path__ + "static/media/devansh.edc519a6.png";